import { Driver } from "../../objects/policy";
import DataLabel from "../typography/DataLabel";

function ReviewDriversList(props: any){
    const { drivers } = props;

    return <>
    {
        (drivers as Driver[]).map(function(v, i){
            console.log({ date_of_birth: v.dob});

            if(v.status === "REVIEW"){
                return;
            }

            return <div key={"driver-"+v.driverNumber} className="container-covered-driver border border-gray-300 p-2 rounded mt-4 last:mb-6">
                <div className="row">
    
                    <DataLabel>Name</DataLabel><br/>
                    <span className="">{v.firstName} {v.lastName}</span>
                </div>
                <div className="row">
                    <div className="float-left">
                        <DataLabel>Marital Status</DataLabel> <br/>
                        <span className="">{v.isMarried ? "Married" : "Single"}</span>
                    </div>
                    <div className="float-right">
                        <DataLabel>Date of Birth</DataLabel><br/>
                        <span className="">{v.dob == null ? "": new Date(v.dob).getUTCMonth()+1 + "/" + (new Date(v.dob).getUTCDate()) + "/" + new Date(v.dob).getUTCFullYear() }</span>
                        
                    </div>
                </div>                    
                <div className="clear-both"></div>
            </div>
        })
    }
    </>;
}

export default ReviewDriversList